import { getClient } from "../components/navigation/oidc/customOidcUtils";

export const getApiFetch = () => {
  const oidc = getClient();
  if (!oidc || localStorage.getItem("OIDC_DISABLE_SW") !== "1")
    return window.fetch;
  return oidc.fetchWithTokens(window.fetch);
};
